import { GET_USER_RIGHTS_REQUEST, GET_USER_RIGHTS_SUCCESS, GET_USER_RIGHTS_ERROR } from "./types";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");
export const getRights = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_USER_RIGHTS_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/get_admin_menu_user_right`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id }
    })
        .then((response) => {
            return dispatch({ type: GET_USER_RIGHTS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_USER_RIGHTS_ERROR,
                payload: error.response,
            });
        });
};
